import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Doc = createSvgIcon(React.createElement("path", { d: "M16.247,0.294H3.115V23.76h19.576V6.734L16.247,0.294zM5.115,21.76V2.294h9.482v5.854h6.094V21.76H5.115z" }), 'Doc');
export default Doc;
